import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

Vue.use(Vuex)

// 从localStorage加载用户信息
const loadUserInfo = () => {
  try {
    const userInfo = localStorage.getItem('userInfo');
    if (userInfo) {
      return JSON.parse(userInfo);
    }
  } catch (e) {
    console.error('加载用户信息失败:', e);
  }
  return null;
};

// 初始化state
const initState = () => {
  const userInfo = loadUserInfo();
  if (userInfo) {
    return {
      ...state,
      userinfo: userInfo
    };
  }
  return state;
};

export default new Vuex.Store({
    state: initState(),
    mutations,
    actions,
    getters,
})